import { Flex, HTMLChakraProps } from '@chakra-ui/react';
import Acl from '@public/images/landing/conferences/acl.png';
import AIP from '@public/images/landing/conferences/AIP-black.png';
import Wiley from '@public/images/landing/conferences/Wiley.png';
import NextImage from 'next/legacy/image';
import { FC } from 'react';

import ASME from '@/assets/images/logos/ASME.png';
import Ieee from '@/assets/images/logos/ieee.png';

export const LibrariansScienceOrganizations: FC<HTMLChakraProps<'div'>> = ({ ...rest }) => {
  return (
    <Flex
      justify="center"
      flexWrap="wrap"
      maxW="560px"
      mx="auto"
      align="center"
      columnGap={{ base: 12, lg: 20 }}
      rowGap={20}
      {...rest}
    >
      <NextImage width="126" height="76" src={ASME} alt="ASME" layout="fixed" />

      <NextImage width="85" height="72" src={AIP} alt="AIP" layout="fixed" />

      <NextImage width="125" height="38" src={Ieee} alt="IEEE" layout="fixed" />

      <NextImage width="146" height="31" src={Wiley} alt="Wiley" layout="fixed" />

      <NextImage width="122" height="120" src={Acl} alt="Acl" layout="fixed" />
    </Flex>
  );
};
